<template>
    <div class="popover" :class="{'popover--visible': isPopped}" @click="unpop">
        <div class="popover__content" ref="popoverContent" :style="{left: `${contentOffset}px`}">
            <slot></slot>
        </div>
        <button 
            type="button" 
            tabindex="-1" 
            ref="popoverButton"
            :class="`popover__button ${buttonClass}`"
            @mouseover="pop"
            @mouseout="unpop"
            @click="togglepop"
        >
            {{ name }}
        </button>
    </div>
</template>
<script>
import { WithBreakpointComponent } from './breakpoints';
export default {
    mixins: [WithBreakpointComponent],
    props: {
       name: {type: String, required: true},
       parent: {type: String, default: ''},
       buttonClass: {type: String, default: ''}
    },
    data: () => ({
        isPopped: false,
        isScrolling: false,
        contentOffset: 0,
        popEvent: '',
        timeout: null,
        parentElem: null,
        container: null
    }),
    mounted() {
        if (this.parent) {
            this.container = document.querySelector(this.parent);
            this.$refs.popoverContent.style.maxWidth = `${this.container.getBoundingClientRect().width - 20}px`;
        }
        this.parentElem = document.getElementById('app');
        this.resetContentOffset();
        window.addEventListener('resize', this.handleResize, false);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    }, 
    methods: {
        handleResize() {
            this.isScrolling = false;
            this.unpop({type: 'resize'}); 
        },
        handleClick() {
            this.parentElem.removeEventListener('click', this.handleClick);
            this.unpop({type: 'toggle'});
        },
        togglepop() {
            if (this.isPopped) {
                this.unpop({type: 'toggle'});
            } else {
                this.pop({type: 'toggle'});
            }
        },
        pop(event) { 
            if (!this.isPopped) {
                this.addPointerCursor();
                this.popEvent = event.type;
                this.getNewContentOffset();
                this.isPopped = true; 
                this.panToTop();
            }
        }, 
        unpop(event) { 
            if (this.isPopped && !this.isScrolling) {
                if (event.type === 'toggle' ||
                    event.type === 'resize' ||
                    event.type === 'mouseout') {
                    this.removePointerCursor();
                    this.isPopped = false;
                    this.prepareReset();
                }
            }
        },
        prepareReset() {
            if (this.timeout) { window.clearTimeout(this.timeout); }
            this.timeout = window.setTimeout(this.resetContentOffset, 200);
        },
        resetContentOffset() {
            const buttonBox = this.$refs.popoverButton.getBoundingClientRect();
            const contentBox = this.$refs.popoverContent.getBoundingClientRect();
            this.contentOffset = (buttonBox.width / 2) - (contentBox.width / 2);
        },  
        getNewContentOffset() {
            const windowWidth = this.container ? this.container.getBoundingClientRect().width : window.innerWidth;
            const buttonBox = this.$refs.popoverButton.getBoundingClientRect();
            const contentBox = this.$refs.popoverContent.getBoundingClientRect();
            let offset = 0;
            
            if (this.timeout) { window.clearTimeout(this.timeout); }
             
            if ((contentBox.width + contentBox.x) > windowWidth) {
                offset = (windowWidth - contentBox.width - buttonBox.x - 20);
                this.contentOffset = offset;
            } else if (contentBox.x < 0) {
                this.contentOffset = 20;
            } else {
                this.contentOffset = (buttonBox.width / 2) - (contentBox.width / 2);
            }
        },
        panToTop() {
            const headerHeight = (this.currentBreakpoint === 'phone')
                    ? 80 // Mobile header height
                    : (this.currentBreakpoint === 'tablet')
                        ? 100 // Tablet header height
                        : 126; // Greater than tablet header height
            this.isScrolling = true;
            if (this.container) {
                const scrollPanel = $('.where-we-build__scroll-panel');
                const offset = scrollPanel.scrollTop() + $(this.$refs.popoverContent).offset().top - headerHeight - 80;
                scrollPanel.animate({scrollTop: offset}, 300, 'swing', () => {
                    this.isScrolling = false;
                    this.parentElem.addEventListener('click', this.handleClick);
                });
            } else {
                const contentBox = this.$refs.popoverContent.getBoundingClientRect();
                if (contentBox.top - headerHeight < 0) {
                    const offset = $(this.$refs.popoverContent).offset().top - headerHeight - 40;
                    $('html,body').animate({scrollTop: offset}, 300, 'swing', () => {
                        this.isScrolling = false;
                        this.parentElem.addEventListener('click', this.handleClick);
                    });
                }
            }
        },
        addPointerCursor() {
            this.parentElem.style.cursor = 'pointer';
        },
        removePointerCursor() {
            this.parentElem.style.cursor = 'default';
        }
    }
}; 
</script>
